module.exports = __webpack_public_path__ + "img/partner10.869b41eb.png";